import React from 'react';
import PieChart from '../charts/PieChart'
import BlockChart from "../BlockChart";

const ConsentPie = ( { source, title, data=[], loaderProps } ) => {
  const defaultData = [{"name":"all","y":0},{"name":"media","y":0},{"name":"data","y":0},{"name":"none","y":0}]

  const chartData = data.reduce((acc, current) => {
    if (current.media_consent && current.data_consent) {
      acc[0].y += current[source]
    } else if (current.media_consent && !current.data_consent) {
      acc[1].y += current[source]
    } else if (!current.media_consent && current.data_consent) {
      acc[2].y += current[source]
    } else if (!current.media_consent && !current.data_consent) {
      acc[3].y += current[source]
    }
    return acc
  }, [...defaultData])

  return (
    <BlockChart title={title} {...loaderProps}>
      <PieChart data={chartData}/>
    </BlockChart>
  )
}

export default ConsentPie
